/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'chat': {
    viewBox: '0 0 24 24',
    data: `<path d="M8,12h5v1H8ZM8,9h8v1H8Zm4.87,10L12,18.5,14,15h3a1,1,0,0,0,1-1V8a1,1,0,0,0-1-1H7A1,1,0,0,0,6,8v6a1,1,0,0,0,1,1h4.5v1H7a2,2,0,0,1-2-2V8A2,2,0,0,1,7,6H17a2,2,0,0,1,2,2v6a2,2,0,0,1-2,2H14.58Z" style="fill-rule:evenodd"/>`
  }
})
